import React from "react";
import { Helmet } from "react-helmet-async";
import MarketingLayout from "../../marketing/components/MarketingLayout";

const MentionsLegales = () => (
  <MarketingLayout showFinalCta={false}>
    <Helmet>
      <title>Mentions légales - ASAP Hub</title>
      <meta name="description" content="Mentions légales du site ASAP Hub : propriétaire, hébergeur, propriété intellectuelle, limitations de responsabilité." />
      <link rel="canonical" href="https://www.asap-hub.ai/resource/MentionsLegales" />
    </Helmet>

    <header className="mk-legal-hero">
      <div className="mk-wrap">
        <span className="mk-eyebrow">
          <span className="mk-pulse" aria-hidden="true" />
          Informations légales
        </span>
        <h1>Mentions légales</h1>
        <p className="mk-lead">
          En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique.
        </p>
      </div>
    </header>

    <section className="mk-legal-body">
      <div className="mk-wrap">
        <div className="mk-legal-card mk-reveal">
          <p>
            Il est précisé aux utilisateurs du site <strong>www.asap-hub.ai</strong> l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi.
          </p>

          <h2>1. Propriétaire du site</h2>
          <p>
            ASAP Hub<br />
            SAS au capital de 1 000 €<br />
            Siège social : 231 Rue Saint-Honoré, 75001 Paris<br />
            Email : <a href="mailto:sadoun.ahmed@asap-cv.fr">sadoun.ahmed@asap-cv.fr</a><br />
            SIRET : 93205471100019
          </p>

          <h2>2. Directeur de la publication</h2>
          <p>Ahmed SADOUN</p>

          <h2>3. Hébergeur</h2>
          <p>
            Google Cloud Platform<br />
            Google France<br />
            8 rue de Londres, 75009 Paris, France
          </p>

          <h2>4. Propriété intellectuelle et contrefaçons</h2>
          <p>
            ASAP Hub est propriétaire des droits de propriété intellectuelle ou détient les droits d'usage sur tous les éléments accessibles sur le site, notamment les textes, images, graphismes, logo, icônes, sons, logiciels. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de ASAP Hub.
          </p>

          <h2>5. Limitations de responsabilité</h2>
          <p>
            ASAP Hub ne pourra être tenu responsable des dommages directs et indirects causés au matériel de l'utilisateur, lors de l'accès au site www.asap-hub.ai, et résultant soit de l'utilisation d'un matériel ne répondant pas aux spécifications indiquées, soit de l'apparition d'un bug ou d'une incompatibilité.
          </p>
        </div>
      </div>
    </section>
  </MarketingLayout>
);

export default MentionsLegales;
